export default __webpack_public_path__ + "static/media/Logo_HymnsAM@3x.9fad3c03.png";